# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/

checkedItems = []

window.get_selected_multiselect = (selector) ->
  return $(selector + " input[type='checkbox']:checked")

window.set_multiselect_text = (selector, t) ->
  if(t == null)
    $(selector + " .multiselect-selected-text").text($(selector + " .multiselect-selected-text").data("placeholder"))
  else
    $(selector + " .multiselect-selected-text").text(t)

window.update_multiselect_text = (selector) ->
  options = get_selected_multiselect(selector)
  if(options.length == 0)
    set_multiselect_text(selector, null)
  else if(options.length <= $(selector).data("limit"))
    set_multiselect_text(selector, options.siblings(".custom-control-description").map( ->
      return $(this).text()
    ).get().join(", "))
  else
    set_multiselect_text(selector, options.length + " selected")

window.set_active_subtopics = (topics) ->
  #Custom multiselect drop-down
  $("#quiz-subtopic-multiselect label.dropdown-item[data-topic]").hide()
  topics.each( ->
    $("#quiz-subtopic-multiselect label.dropdown-item[data-topic=" + this.value + "]").show()
  )

# Get appropriate number of selected questions
window.get_checked_count = ->
  # checkedItems = JSON.parse(sessionStorage.getItem('checkedItems'))
  # # console.log(checkedItems)
  # if checkedItems == null
  #   checkedItems = []
  # Get number of questions in session data
  totalQuestions = checkedItems.length
#  console.log('CheckedItems: ' + totalQuestions)
  # For checked elements on current page, add to counter if not already in session data
  $(".quiz-and-question-check:checkbox").each ->
    if checkedItems.indexOf(this.value) < 0 && this.checked
      totalQuestions += 1
    else if checkedItems.indexOf(this.value) > -1 && !this.checked
      totalQuestions -= 1
  return totalQuestions

window.update_checked_questions = ->
  # Get selected questions from session data
  # checkedItems = JSON.parse(sessionStorage.getItem('checkedItems'))
  # Check off appropriate elements when transitioning between pages in quiz creation

  # if checkedItems == null then checkedItems = []
  $(".quiz-and-question-check:checkbox").each( ->
    # Add any checked items not already in list
    if (this.checked && checkedItems.indexOf(this.value) < 0)
      checkedItems.push(this.value)
    # Remove any unchecked items from list of selected questions
    else if (checkedItems != null && checkedItems.indexOf(this.value) > -1 && !this.checked)
      checkedItems.splice(checkedItems.indexOf(this.value), 1)
  )
  # Save checked questions as JSON string
  sessionStorage.setItem('checkedItems', JSON.stringify(checkedItems))

$(document).on "turbolinks:load", ->

  ## Begin Quiz Creation Pagination
# Selected questions are stored in sessionStorage
  checkedItems = JSON.parse(sessionStorage.getItem('checkedItems'))

  # For Editing Quiz Assignments
  if $("#assignment_quiz_form").length > 0 && checkedItems == null
    checkedItems = []
    data = $('div[data-checked-quizzes]').data('checked-quizzes')
    for i in data
      checkedItems.push(i.toString())

  if (checkedItems != null)
    $(".quiz-and-question-check:checkbox").each ->
      if checkedItems.indexOf(this.value) > -1
        this.checked = true
  else
    checkedItems = []





  # Before changing pages, save checked questions to session data
  $(".page, .next, .prev, .last, .first, #step_1_continue_btn").click( (event) ->
    update_checked_questions()
  )

  # Clear any old session data when making new quiz, after saving a quiz, or editing a quiz
  $("#step_0_continue_btn, #step_2_save_btn, .quiz_edit_btn, #edit_add_more, #new_add_more, #new_save_quiz, #edit_save_quiz, #draft-continue, #edit_assignment_content_btn").click((event) ->
    sessionStorage.clear()
  )

  ## End of quiz creation pagination

  # Submit the step 1 form
  $("#step_1_continue_btn").click((event) ->
    # Call the real hidden submit button
    $('#continue_btn').click()
  )

  #Not ideal, should we have it just switch them?
  $("img.switch-image").hover( () ->
    $(this).attr("src", $(this).data("alt-img"))
  , () ->
    $(this).attr("src", $(this).data("base-img"))
  )

  starting_topics = get_selected_multiselect("#quiz-topic-multiselect")
  #Custom multiselect drop-down
  $("#quiz_subtopic-multiselect-btn").prop('disabled', starting_topics.length == 0)
  $("#quiz_question_subtopic-multiselect-btn").prop('disabled', starting_topics.length == 0)
  update_multiselect_text("#quiz-author-multiselect")
  update_multiselect_text("#quiz-topic-multiselect")
  if starting_topics.length > 0
    set_active_subtopics(starting_topics)
    update_multiselect_text("#quiz-subtopic-multiselect")

  $("#quiz-topic-multiselect input[type='checkbox']").on("change", (e) ->
    checked_topics = get_selected_multiselect("#quiz-topic-multiselect")
    if checked_topics.length == 0
      #Custom multiselect drop-down
      $("#quiz_subtopic-multiselect-btn").prop('disabled', true)
      $("#quiz_question_subtopic-multiselect-btn").prop('disabled', true)
      $("#quiz-subtopic-multiselect label.dropdown-item[data-topic]").hide()
    else
      #Custom multiselect drop-down
      $("#quiz_subtopic-multiselect-btn").prop('disabled', false)
      $("#quiz_question_subtopic-multiselect-btn").prop('disabled', false)
      set_active_subtopics(checked_topics)

    get_selected_multiselect("#quiz-subtopic-multiselect").prop('checked', false)
    update_multiselect_text("#quiz-subtopic-multiselect")
    update_multiselect_text("#quiz-topic-multiselect")
  )

  $("#quiz-author-multiselect input[type='checkbox']").on("change", (e) ->
    checked_authors = get_selected_multiselect("#quiz-author-multiselect")

    update_multiselect_text('#quiz-author-multiselect')
  )

  $("#quiz-subtopic-multiselect label[data-topic] input[type='checkbox']").on("change", (e) ->
    if $(this).prop('checked')
      $("#quiz-subtopic-multiselect label:not([data-topic]) input[type='checkbox']").prop('checked', false)
    update_multiselect_text("#quiz-subtopic-multiselect")
  )

  $("#quiz-subtopic-multiselect label:not([data-topic]) input[type='checkbox']").on("change", (e) ->
    if $(this).prop('checked')
      $("#quiz-subtopic-multiselect label[data-topic] input[type='checkbox']").prop('checked', false)
    update_multiselect_text("#quiz-subtopic-multiselect")
  )

  $("form.submit-on-select-change select").on("change", (e) ->
    update_checked_questions()
    $("#clearable-search-form").submit()
  )

  $("form.submit-on-select-change .multiselect-dropdown input").on("change", (e) ->
    update_checked_questions()
    $("#clearable-search-form").submit()
  )

  $("#clearable-search-reset, #clearable-search-submit").on("click", (e) ->
    update_checked_questions()
  )

  $(".multiselect-dropdown label.dropdown-item").on("click", (e) ->
    e.stopPropagation()
  )

  #Highlight text on select
  $(".quiz-and-question-list .display-text").each( ->
    link_parent = this
    $(this).children("a").on("click", (e) ->
      if !$(link_parent).hasClass("selected")
        $(".quiz-and-question-list .display-text.selected").removeClass("selected")
        $(link_parent).addClass("selected")
    )
  )

  $("#create-question-from-quiz").on("click", (e) ->
    if confirm($(this).data("dialog"))
      # for i in checkedItems
        # $('<input>').attr({type: 'hidden',name: 'question_keys[]',value: i}).appendTo('#quiz_question_select_form')
      $("#quiz_question_select_form").submit()
  )


  $(".quiz-sortable").sortable({
    axis: 'y',
    scroll: 'true',
    items: "> li:not(.sortable-ignore)",
  })

  if $(".quiz-and-question-check").length > 0
    setCount(get_checked_count)
    # setCount($(".quiz-and-question-check:checkbox:checked").length)

  if $(".quiz-and-question-check:checkbox:checked").length > 0 && $(".quiz-and-question-check:visible:checkbox:not(checked)").length > 0
    $("#chk-select-all").prop("indeterminate", true)

  $(".quiz-and-question-check").on("change", (e) ->
    checkedCount = $(".quiz-and-question-check:checkbox:checked").length
    # checkedCount = checkedItems.length
    setCount(get_checked_count)
    $("#chk-select-all").prop("checked", false)
    if checkedCount == 0
        $("#chk-select-all").prop("indeterminate", false)
    else
        $("#chk-select-all").prop("indeterminate", true)
  )

  $("#chk-select-all").on("change", (e) ->
    if $(this).prop('checked')
        $(".quiz-and-question-check:visible").prop('checked', true)
    else
        $(".quiz-and-question-check").prop('checked', false)

    setCount(get_checked_count)
    # setCount($(".quiz-and-question-check:checkbox:checked").length)
  )

  $('#quiz_question_select_form').on("submit", (e) ->
    # update_checked_questions()
    # Don't add duplicate input fields for checked elements on page
    $(".quiz-and-question-check:checkbox:checked").each ->
      if checkedItems.indexOf(this.value) >= 0
        checkedItems.splice(checkedItems.indexOf(this.value), 1)

    for i in checkedItems
       $('<input>').attr({type: 'hidden', name: 'question_keys[]', value: i}).appendTo('#quiz_question_select_form')
       $('<input>').attr({type: 'hidden', name: 'quiz[add_quiz_question_ids][]', value: i}).appendTo('#quiz_question_select_form')

    # if $(".quiz-and-question-check:checkbox:checked").length > max_quiz_assets
    if (get_checked_count > max_quiz_assets)
        alert(max_quiz_error)
        return false
    else
        $('#chk-select-all').prop('disabled', true);
        return true;
  )

  $('#assignment_quiz_form').on("submit", (e) ->
    # Don't add duplicate input fields for checked elements on page
    $(".quiz-and-question-check:checkbox:checked").each ->
      if checkedItems.indexOf(this.value) >= 0
        checkedItems.splice(checkedItems.indexOf(this.value), 1)

    for i in checkedItems
      $('<input>').attr({type: 'hidden', name: 'link_keys[]', value: i}).appendTo('#assignment_quiz_form')
    #      $('<input>').attr({type: 'hidden', name: 'quiz[add_quiz_question_ids][]', value: i}).appendTo('#quiz_question_select_form')

    return true;
  )
